import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { URL } from "../../utils/Constants";
import { axiosPost } from "../../utils/AxiosApi";
import CreateSymbolNumber from "./CreateSymbolNumber";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import Pagination from "../UI/Pagination";

const animatedComponents = makeAnimated();

function SymbolNumber(props) {
  const [isLoading, setIsLoading] = useState(false);
  // for education level
  const [classValue, setClassValue] = useState(null);
  const [educationLevel, setEducationLevel] = useState({});
  const [educationLevelAllData, setEducationLevelAllData] = useState(null);

  // for assessment type
  const [assessmentSubjectValue, setAssessmentSubjectValue] = useState(null);
  const [assessmentAllData, setAssessmentAllData] = useState(null);
  const [assessmentSubjectList, setAssessmentSubjectList] = useState({});

  // for class
  const [classRooms, setClassRooms] = useState(null);
  const [classroomsList, setClassroomsList] = useState([]);

  // for class section
  const [classSections, setClassSections] = useState(null);
  const [classSectionsList, setClassSectionsList] = useState([]);

  // for students
  const [student, setStudent] = useState(null);
  const [studentInfos, setStudentInfos] = useState([]);
  const [studentInfosNew, setStudentInfosNew] = useState(studentInfos);

  // for symbol number
  const [symbolVal, setSymbolVal] = useState("");
  // loading
  const [studentSave, setStudentSave] = useState(false);
  const [studentSaveId, setStudentSaveId] = useState(null);

  // symbol no generate states
  const [prefix, setPrefix] = useState("");
  const [midNumber, setMidNumber] = useState("");
  const [suffix, setSuffix] = useState("");

  const [sortType, setsortType] = useState("asc");
  const [sortedStudents, setSortedStudents] = useState([]);

  const [sectionDisabled, setSectionDisabled] = useState(true);

  const [totalStudentsCount, setTotalStudentsCount] = useState(0);

  const [pageValue, setPageValue] = useState(10);

  const [currentPageValue, setCurrentPageValue] = useState(1);

  const [generateClicked, setGenerateClicked] = useState(false)


  const handleClassChange = (value) => {
    setClassValue(value);
    getAssessments(value?.id);
    setAssessmentSubjectValue(null);
    setClassRooms(null);
    setClassSections(null);
    setSuffix("");
    setMidNumber("");
    setPrefix("");
    setsortType("asc");
  };

  const getAssessments = (param) => {
    let data = {
      educationLevelId: param,
    };
    axiosPost(URL.getAssessmentWithScaleOrComment, data, (response) => {
      if (response.data.status === 200) {
        setAssessmentAllData(response.data.data);
      }
    });
  };

  const handleAssessmentListChange = (value) => {
    setAssessmentSubjectValue(value);
    setClassRooms(null);
    setClassSections(null);
    setStudentInfos(null);
    setsortType("asc");
    setSuffix("");
    setMidNumber("");
    setPrefix("");
  };

  const getStudentList = (assessId, yearLevelId, classroomId, offsetValue) => {
    setStudentInfosNew(null);
    setStudentInfos(null);
    setIsLoading(true);
    let data = {
      assessmentId: assessId,
      educationLevelId: classValue?.id,
      yearLevelId: yearLevelId ? yearLevelId : null,
      classroomId: classroomId ? classroomId : null,
      offset: (offsetValue) * parseInt(pageValue) - parseInt(pageValue),
      rowCountLimit: pageValue,
      order: sortType
    };
    axiosPost(
      URL.getStudentWithAssessmentRoutine,
      data,
      (response) => {
        setSectionDisabled(false);
        if (response.status === 200) {
          // let unsortedData = response.data.data;
          // let sortedData = unsortedData.sort((a, b) => a.people.name.localeCompare(b.people.name));
          const trimmedData = response?.data?.data?.map(student => {
            if (student?.people && typeof student?.people?.name === 'string') {
              return {
                ...student,
                people: {
                  ...student.people,
                  name: student.people.name.trim(),
                },
              };
            }
            return student;
          });
          setStudentInfos(trimmedData);

          // setStudentInfos(trimmedData);
          if (prefix !== "" && midNumber !== "" && generateClicked) {
            // handleSymbolGenerate("symbolNoExists");

            generateExistingSymbolNo(response?.data?.data, offsetValue);

          }
          setIsLoading(false);
          setTotalStudentsCount(response?.data?.totalRecordsCount);
        }
      },
      (err) => {
        setSectionDisabled(true);
        setIsLoading(false);
      }
    );
  };

  const handleClassRoomListChange = (value) => {
    setClassRooms(value);
    setClassSections(null);
    setSuffix("");
    setMidNumber("");
    setPrefix("");
    setsortType("asc");
    setCurrentPageValue(1);
    if (value?.id) {
      getStudentList(assessmentSubjectValue?.id, value?.id, null, 1);
      getSectionsList(value?.id);
    } else {
      getStudentList(assessmentSubjectValue?.id, null, null, 1);
      setClassSectionsList({});
    }
  };

  const handleClassSectionListChange = (value) => {
    setClassSections(value);
    setSuffix("");
    setMidNumber("");
    setPrefix("");
    setsortType("asc");
    setCurrentPageValue(1);
    if (value?.id) {
      getStudentList(assessmentSubjectValue?.id, classRooms?.id, value?.id, 1);
    } else {
      getStudentList(assessmentSubjectValue?.id, classRooms?.id, null, 1);
    }
  };

  useEffect(() => {
    getEducationLevels();
  }, []);

  useEffect(() => {
    let assessmentallDatas = assessmentAllData;
    let selectedData = classValue;
    if (assessmentallDatas && selectedData) {
      let assessmentOptions = assessmentallDatas?.map((item) => ({
        ...item,
        value: item.id,
        label: item.assessmentName,
      }));
      setAssessmentSubjectList(assessmentOptions);
    }
  }, [assessmentAllData]);

  useEffect(() => {
    let allData = educationLevelAllData;
    let selectedData = classValue;
    if (allData && selectedData) {
      let yearLevels = allData.filter((item) => item.id === selectedData.id)[0]
        ?.yearLevels;
      let YearLevelOptions = yearLevels?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setClassroomsList(YearLevelOptions);
    } else {
      setClassroomsList({});
    }
  }, [classValue]);

  useEffect(() => {
    if (studentInfos) {

      setSymbolVal((prevSymbolVal) => {
        let newSymbolVal = {};
        studentInfos.forEach((student) => {
          newSymbolVal[student.id] = student.symbolNo;
        });
        return newSymbolVal;
      });
    }
  }, [studentInfos]);

  const getEducationLevels = () => {
    axiosPost(URL.getEducationLevel, {}, (response) => {
      if (response.data.status === 200) {
        const data = response.data.data;
        setEducationLevelAllData(data);
        setEducationLevel(
          data?.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }))
        );
      }
    });
  };

  const handleSymbolNoChange = (e, id) => {
    const { value } = e.target;
    setStudentInfos(prev => {
      const newStudents = [...prev];
      const index = newStudents.findIndex(student => student.id === id);
      if (index !== -1) {
        newStudents[index] = {
          ...newStudents[index],
          symbolNo: value
        };
      }
      return newStudents;
    });
    setSymbolVal(prev => ({ ...prev, [id]: value }));
  };

  const handleSave = (id) => {
    setStudentSaveId(id);
    setStudentSave(true);
    let sympbolStudent = studentInfos?.filter((item) => item?.id === id)[0];
    let data = [
      {
        assessmentId: assessmentSubjectValue?.id,
        educationLevelId: classValue?.id,
        yearLevelId: classRooms ? classRooms?.id : null,
        classroomId: sympbolStudent?.classRoom?.id,
        admissionId: id,
        symbolNo: sympbolStudent ? sympbolStudent?.symbolNo : null,
      },
    ];
    axiosPost(URL.insertStudentAssessmentSymbolNumber, data,
      (response) => {
        if (response.status === 200) {
          setStudentSave(false);
          let updatedStudentInfos = studentInfosNew?.map((student) => {
            if (student.id === id) {
              return { ...student, symbolNo: sympbolStudent.symbolNo };
            }
            return student;
          });
          swal({
            title: "Success",
            text: `Student assessment symbol number saved successfully.`,
          });
          setStudentInfosNew(updatedStudentInfos);
          if (updatedStudentInfos) {
            setSymbolVal((prevSymbolVal) => {
              let newSymbolVal = {};
              updatedStudentInfos.forEach((student) => {
                newSymbolVal[student.id] = student.symbolNo;
              });
              return newSymbolVal;
            });
          }
          setStudentInfosNew(studentInfos);
          setSymbolVal((prevSymbolVal) => {
            let newSymbolVal = {};
            studentInfos.forEach((student) => {
              newSymbolVal[student.id] = student.symbolNo;
            });
            return newSymbolVal;
          });
        } else {
          setStudentSave(false);
          swal({
            title: "Oops",
            text: `Failed to save student assessment symbol number, Please try again.`,
          });
        }
      },
      (error) => {
        setStudentSave(false);
        if (error.response) {
          swal({
            title: `Error: ${error?.response?.data?.error}`,
            text: `${error?.response?.data?.message}`,
          });
        } else {
          swal({
            title: "Oops",
            text: `Failed to save student assessment symbol number. An error occurred.`,
          });
        }
      }
    );
  };

  const handleSaveAll = () => {
    setIsLoading(true);

    let clicked = generateClicked;

    let dataClicked = {
      prefix: prefix,
      startValue: midNumber,
      suffix: suffix,
      yearLevelId: classRooms?.id ?? null,
      assessmentId: assessmentSubjectValue?.id ?? null,
      classroomId: classSections?.id ?? null,
      educationLevelId: classValue?.id ?? null
    }

    let dataUnclicked = studentInfos?.map((item) => ({
      assessmentId: assessmentSubjectValue?.id,
      educationLevelId: classValue?.id,
      yearLevelId: classRooms ? classRooms?.id : null,
      classroomId: item?.classRoom?.id,
      admissionId: item?.id,
      symbolNo: item?.symbolNo,
    }));


    axiosPost(clicked ? URL.generateStudentAssessmentSymbolNumber : URL.insertStudentAssessmentSymbolNumber,
      clicked ? dataClicked : dataUnclicked,
      (response) => {
        if (response.status === 200) {
          setGenerateClicked(false);
          setIsLoading(false);
          setPrefix("");
          setMidNumber("");
          setSuffix("");
          getStudentList(assessmentSubjectValue?.id, classRooms?.id, classSections?.id, 1)
          swal({
            title: "Success",
            text: `All students assessment symbol number saved successfully.`,
          });
          let updatedStudentInfos = studentInfos?.map((student) => {
            return { ...student, symbolNo: student.symbolNo };
          });
          setStudentInfosNew(updatedStudentInfos);
          setSymbolVal((prevSymbolVal) => {
            let newSymbolVal = {};
            updatedStudentInfos.forEach((student) => {
              newSymbolVal[student.id] = student.symbolNo;
            });
            return newSymbolVal;
          });
        } else {
          setIsLoading(false);
          swal({
            title: "Oops",
            text: `Failed to save all students assessment symbol number. Please try again.`,
          });
        }
      },
      (error) => {
        setIsLoading(false);
        if (error.response) {
          swal({
            title: `Error: ${error?.response?.data?.error}`,
            text: `${error?.response?.data?.message}`,
          });
        } else {
          swal({
            title: "Oops",
            text: `Failed to save all students assessment symbol number. An error occurred.`,
          });
        }
      }
    );
  };

  const getSectionsList = (value) => {
    let data = {
      yearLevelId: value,
    };
    axiosPost(URL.selectClassroom, data, (response) => {
      if (response.status === 200) {
        let sectionOptions = response?.data?.data?.map((item) => ({
          ...item,
          value: item?.id,
          label: item?.name,
        }));
        setClassSectionsList(sectionOptions);
      }
    });
  };

  function generatePaddedNumbers(startValue, count) {
    // Get number of digits in the input (preserve leading zeros)
    const padLength = startValue.length;
    const startNum = parseInt(startValue, 10);
    const endNum = startNum + count - 1;

    const result = [];
    for (let i = startNum; i <= endNum; i++) {
      result.push(i.toString().padStart(padLength, '0'));
    }
    return result;
  }

  const handleSymbolGenerate = (type) => {
    // handleGenerateSymbolNoApi();
    // const students = [...sortedStudents];
    // for (let i = 0; i < students.length; i++) {
    //   let symbolNo;
    //   if (midNumber.startsWith("0")) {
    //     const numDigits = midNumber.length;
    //     const incrementedMidNumber = (parseInt(midNumber) + i).toString();
    //     symbolNo = `${prefix}${incrementedMidNumber.padStart(numDigits, '0')}${suffix}`;
    //   } else {
    //     symbolNo = `${prefix}${parseInt(midNumber) + i}${suffix}`;
    //   }
    //   students[i] = { ...students[i], symbolNo };
    // }

    // setStudentInfos(students);

    // const symbolMap = {};
    // for (let i = 0; i < students.length; i++) {
    //   symbolMap[students[i].id] = students[i].symbolNo;
    // }

    // setSymbolVal(symbolMap);
    setGenerateClicked(true);
    const students = [...studentInfos];
    let symbolNoExist = (parseInt(midNumber) + (currentPageValue * pageValue)) - parseInt(pageValue);
    const paddedNumbers = generatePaddedNumbers(type === "symbolNoExists" ? symbolNoExist : midNumber, students.length);
    for (let i = 0; i < students.length; i++) {
      const symbolNo = `${prefix}${paddedNumbers[i]}${suffix}`;
      students[i] = { ...students[i], symbolNo };
    }
    setStudentInfos(students);
    const symbolMap = {};
    for (let i = 0; i < students.length; i++) {
      symbolMap[students[i].id] = students[i].symbolNo;
    }
    setSymbolVal(symbolMap);

  };

  const toggleSortOrder = (type) => {
    sortType === "asc" ? setsortType("desc") : setsortType("asc");
    setStudentInfosNew(null);
    setStudentInfos(null);
    setIsLoading(true);
    let data = {
      assessmentId: assessmentSubjectValue?.id,
      classroomId: classSections?.id,
      educationLevelId: classValue?.id,
      offset: (currentPageValue) * parseInt(pageValue) - parseInt(pageValue),
      rowCountLimit: pageValue,
      yearLevelId: classRooms?.id,
      order: type
    }

    axiosPost(
      URL.getStudentWithAssessmentRoutine,
      data,
      (response) => {
        setSectionDisabled(false);
        if (response.status === 200) {
          const trimmedData = response?.data?.data?.map(student => {
            if (student?.people && typeof student?.people?.name === 'string') {
              return {
                ...student,
                people: {
                  ...student.people,
                  name: student.people.name.trim(),
                },
              };
            }
            return student;
          });
          setStudentInfos(trimmedData);
          if (prefix !== "" && midNumber !== "" && generateClicked) {
            generateExistingSymbolNo(response?.data?.data, 1);
          }
          setIsLoading(false);
          setTotalStudentsCount(response?.data?.totalRecordsCount);
        }
      },
      (err) => {
        setSectionDisabled(true);
        setIsLoading(false);
      }
    );
  }

  const generateExistingSymbolNo = (data, offsetValue) => {
    const students = data;
    let offsetPage = offsetValue;

    const padLength = midNumber.length;
    const startNum = (parseInt(midNumber, 10) + (offsetPage * pageValue)) - pageValue;
    const endNum = startNum + students?.length - 1;

    const result = [];
    for (let i = startNum; i <= endNum; i++) {
      result.push(i.toString().padStart(padLength, '0'));
    }
    // return result;

    for (let i = 0; i < students.length; i++) {
      const symbolNo = `${prefix}${result[i]}${suffix}`;
      students[i] = { ...students[i], symbolNo };
    }
    setStudentInfos(students);
    const symbolMap = {};
    for (let i = 0; i < students.length; i++) {
      symbolMap[students[i].id] = students[i].symbolNo;
    }
    setSymbolVal(symbolMap);
  }

  // useEffect(() => {
  //   if (studentInfos) {
  //     const sorted = [...studentInfos].sort((a, b) => {
  //       const nameA = a.people?.name?.trim() ?? '';
  //       const nameB = b.people?.name?.trim() ?? '';
  //       return sortType === "asc"
  //         ? nameA.localeCompare(nameB)
  //         : nameB.localeCompare(nameA);
  //     });
  //     setSortedStudents(sorted);
  //   }
  // }, [studentInfos, sortType]);

  const handleGenerateSymbolNoApi = () => {
    // setIsLoading(true);
    let data = {
      prefix: prefix,
      startValue: midNumber,
      suffix: suffix,
      yearLevelId: classRooms?.id ?? null,
      assessmentId: assessmentSubjectValue?.id ?? null,
      classroomId: classSections?.id ?? null,
      educationLevelId: classValue?.id ?? null
    }

    axiosPost(URL.generateStudentAssessmentSymbolNumber, data,
      (response) => {
        if (response.status === 200) {
          // getStudentList(assessmentSubjectValue?.id, classValue?.id, classRooms?.id, classSections?.id)
          // setIsLoading(false);
          // swal({
          //   title: "Success",
          //   text: `Symbol numbers generated successfully.`,
          // });

        } else {
          // setIsLoading(false);
          swal({
            title: "Oops",
            text: `Failed to generate symbol number. Please try again.`,
          });
        }
      },
      (error) => {
        // setIsLoading(false);
        if (error.response) {
          swal({
            title: `Error: ${error?.response?.data?.error}`,
            text: `${error?.response?.data?.message}`,
          });
        } else {
          swal({
            title: "Oops",
            text: `Failed to generate symbol number. An error occurred.`,
          });
        }
      }
    );
  }

  const allStudentHandlePageChange = (page) => {
    setCurrentPageValue(page);
    getStudentList(assessmentSubjectValue?.id, classRooms?.id, classSections?.id, page)
  };

  const allStudentHandleNextPage = () => {
    let pageVal = currentPageValue + 1
    setCurrentPageValue(pageVal);
    getStudentList(assessmentSubjectValue?.id, classRooms?.id, classSections?.id, pageVal)
  };

  const allStudentHandlePreviousPage = () => {
    let pageVal = currentPageValue - 1
    setCurrentPageValue(pageVal);
    getStudentList(assessmentSubjectValue?.id, classRooms?.id, classSections?.id, pageVal)
  };

  return (
    <div
      className="card-setup-container tt-widgetContent-tab-holder"
      style={{ height: "79.5vh" }}
    >
      <div className="row">
        <div className="col-md-12 col-12">
          <div className="tt-group-header">Configure Symbol Number</div>
          <div className="tt-group-body">
            <div className="d-flex justify-content-between">
              <div className="w-100 mr-1">
                <strong>Education Level:</strong>
                <Select
                  className="w-100 mr-1"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  value={classValue}
                  options={educationLevel}
                  name="class"
                  onChange={handleClassChange}
                  placeholder="Select Level"
                  isClearable
                />
              </div>
              <div className="w-100 mx-1">
                <strong>Assessment:</strong>
                <Select
                  isDisabled={!!!classValue}
                  className="w-100"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  value={assessmentSubjectValue}
                  options={assessmentSubjectList}
                  name="assessmentList"
                  onChange={handleAssessmentListChange}
                  placeholder="Select Assessment"
                  isClearable
                />
              </div>
              <div className="w-100 ml-1">
                <strong>Class</strong>
                <Select
                  isDisabled={!!!assessmentSubjectValue}
                  className="w-100"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  value={classRooms}
                  options={classroomsList}
                  name="classRooms"
                  onChange={handleClassRoomListChange}
                  placeholder="Select Class"
                  isClearable
                />
              </div>
              <div className="w-100 ml-1">
                <strong>Section</strong>
                <Select
                  isDisabled={(!!!classRooms || sectionDisabled)}
                  className="w-100"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  value={classSections}
                  options={classSectionsList}
                  name="section"
                  onChange={handleClassSectionListChange}
                  placeholder="Select Section"
                  isClearable
                />
              </div>
            </div>
            {isLoading ? (
              <div className="mt-4 d-flex align-items-center justify-content-center ">
                {" "}
                <Spinner color="primary"></Spinner>{" "}
              </div>
            ) : (!!classValue &&
              !!assessmentSubjectValue &&
              !!classRooms &&
              studentInfos?.length > 0) ? (
              <div className="mt-1 d-flex flex-column align-items-center justify-content-center">
                <div className="symbolNoGenerator d-flex align-items-center justify-content-around col-12 my-2">
                  <div className="prefixDiv d-flex align-items-center justify-content-center">
                    <p className="m-0">Prefix:</p>
                    <input
                      className="form-control ml-2"
                      placeholder="Enter prefix"
                      value={prefix}
                      onChange={(e) => setPrefix(e.target.value)}
                    />
                  </div>
                  <div className="noGeneratorDiv d-flex align-items-center justify-content-center">
                    <p className="m-0">Number:</p>
                    <input
                      className="form-control ml-2"
                      placeholder="Enter number"
                      type="number"
                      value={midNumber}
                      onChange={(e) => setMidNumber(e.target.value)}
                    />
                  </div>
                  <div className="suffixDiv d-flex align-items-center justify-content-center">
                    <p className="m-0">Suffix:</p>
                    <input
                      className="form-control ml-2"
                      placeholder="Enter suffix"
                      type="text"
                      value={suffix}
                      onChange={(e) => setSuffix(e.target.value)}
                    />
                  </div>
                  <div className="generateBtnDiv"
                    style={(prefix !== "" && midNumber !== "") ?
                      { pointerEvents: "all" } : { pointerEvents: "none" }
                    }
                  >
                    <btn className=
                      {(prefix !== "" && midNumber !== "") ?
                        "generateBtn tt-button tt-button-primary" : "generateBtn tt-button tt-button-primary-disabled"
                      }
                      onClick={() => handleSymbolGenerate()}
                    >Generate</btn>
                  </div>
                </div>
                <CreateSymbolNumber
                  isLoading={isLoading}
                  students={studentInfos}
                  symbolVal={symbolVal}
                  studentSave={studentSave}
                  handleSave={handleSave}
                  handleSymbolNoChange={handleSymbolNoChange}
                  studentSaveId={studentSaveId}
                  sortType={sortType}
                  setsortType={setsortType}
                  toggleSortOrder={toggleSortOrder}
                />
                <div className="mt-1 d-flex align-items-center justify-content-center sticky-bottom w-100 py-1"
                  style={(midNumber !== "") ?
                    { pointerEvents: "all" } : { pointerEvents: "none" }
                  }
                >
                  <btn
                    onClick={() => handleSaveAll()}
                    className=
                    {(midNumber !== "") ?
                      "generateBtn tt-button tt-button-primary" : "generateBtn tt-button tt-button-primary-disabled"
                    }
                  >
                    Save all
                  </btn>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Pagination
                    itemsCount={totalStudentsCount}
                    pageSize={pageValue}
                    currentPage={currentPageValue}
                    onPageChange={allStudentHandlePageChange}
                    nextPage={allStudentHandleNextPage}
                    previousPage={allStudentHandlePreviousPage}
                  ></Pagination>
                </div>
              </div>
            ) : (
              <>
                {(classValue && assessmentSubjectValue && classRooms) ? (

                  <p className='text-center mt-2'>
                    The selected assessment is either not configured for the specified class, or there are no students available in the class.
                  </p>
                ) : (
                  <div className="mt-4 d-flex align-items-center justify-content-center ">
                    Select the above field to view the records.
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SymbolNumber;
